var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFertilizerTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.9,
    height: 42.1,
    viewBox: "0 0 41.9 42.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_17",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_372",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FERTILIZER",
    "data-name": "FERTILIZER",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Vereinigungsmenge_17)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2734",
    d: "M21.254.667v2.026a16 16 0 1 1-6.52 0V.669a18 18 0 1 0 6.52 0",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_372)",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2735",
    d: "M27.937 15.13a10.362 10.362 0 0 1-4.925 12.37c-.282.152-.568.285-.856.408a6.211 6.211 0 0 1-.4 1.209 11.358 11.358 0 0 0 7.211-14.077 9.143 9.143 0 0 0-1.03.09"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2736",
    d: "M16.063 28.538a10.35 10.35 0 0 1-8.238-11.7 6.177 6.177 0 0 1-.837-.957 11.314 11.314 0 0 0 8.658 13.569 9.4 9.4 0 0 0 .417-.912"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2737",
    d: "M30.448 13.185a5.37 5.37 0 0 0-6.063-2 5.363 5.363 0 0 0-3.1 5.563c.047.34.2.529.471.56a.373.373 0 0 0 .057 0 .514.514 0 0 0 .451-.275 8.879 8.879 0 0 1 3.474-2.312.4.4 0 0 0 .062-.021 8.851 8.851 0 0 1 4.124-.636.515.515 0 0 0 .559-.144.559.559 0 0 0-.034-.736m-5.044.6a9.15 9.15 0 0 0-2.412 1.274 5.239 5.239 0 0 1 3.516-2.241l-.059-.5a5.825 5.825 0 0 0-4.05 2.711 3.985 3.985 0 0 1 2.353-2.91 3.885 3.885 0 0 1 1.329-.239 4.5 4.5 0 0 1 2.861 1.146 9.811 9.811 0 0 0-3.534.757"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2738",
    d: "M15.308 15.495a.509.509 0 0 0-.489-.305 8.835 8.835 0 0 1-3.739-1.852.593.593 0 0 0-.056-.043 8.846 8.846 0 0 1-2.611-3.253.514.514 0 0 0-.407-.413c-.267-.05-.471.086-.62.4a5.379 5.379 0 0 0 1.3 6.246 4.787 4.787 0 0 0 2.976 1.025 5.951 5.951 0 0 0 3.4-1.118.553.553 0 0 0 .249-.688m-5.994 0A4.172 4.172 0 0 1 8 11.414a9.809 9.809 0 0 0 2.426 2.686 9.154 9.154 0 0 0 2.309 1.452 5.237 5.237 0 0 1-3.7-1.924l-.4.3a5.828 5.828 0 0 0 4.391 2.151 3.993 3.993 0 0 1-3.712-.579"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2739",
    d: "M17.964 22.022a.552.552 0 0 0-.722.127.515.515 0 0 0-.02.576 8.843 8.843 0 0 1 .267 4.164.413.413 0 0 0-.011.069 8.858 8.858 0 0 1-1.509 3.889.514.514 0 0 0-.157.557.524.524 0 0 0 .555.342h.1a5.374 5.374 0 0 0 4.762-4.251 5.363 5.363 0 0 0-3.265-5.469m2.277 5.317a4.171 4.171 0 0 1-2.881 3.176 9.783 9.783 0 0 0 1.111-3.439 9.093 9.093 0 0 0 .1-2.726 5.24 5.24 0 0 1 .184 4.165l.459.2a5.828 5.828 0 0 0-.319-4.865 3.984 3.984 0 0 1 1.343 3.492"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2740",
    d: "M19.592 21.163a3.184 3.184 0 1 0-1.506.381 3.185 3.185 0 0 0 1.506-.381M16.161 19.4a2.181 2.181 0 1 1 2.956.883 2.184 2.184 0 0 1-2.956-.883"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2741",
    d: "M14.356 7.611a11.311 11.311 0 0 0-4.529 2.924 9.123 9.123 0 0 0 .6.825 9.917 9.917 0 0 1 4.486-2.86 4.021 4.021 0 0 1-.557-.888"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2742",
    d: "M21.658 7.585a4.02 4.02 0 0 1-.535.871A10.451 10.451 0 0 1 24.4 10.14a5.972 5.972 0 0 1 1.273-.231 11.426 11.426 0 0 0-4.019-2.324"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2743",
    d: "M18 9a3.018 3.018 0 0 0 3-3.035C21 4.289 18 0 18 0s-3 4.289-3 5.965A3.018 3.018 0 0 0 18 9m1.335-4.023a.78.78 0 1 1-.771.78.775.775 0 0 1 .771-.78"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizerTool);
export default __webpack_public_path__ + "static/media/fertilizer-tool.da3cfbc08459e46973fce3a317ed42bd.svg";
export { ForwardRef as ReactComponent };